/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manageplan1Inputs */

const en_manageplan1 = /** @type {(inputs: Manageplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Plan`)
};

const de_manageplan1 = /** @type {(inputs: Manageplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan verwalten`)
};

/**
* | output |
* | --- |
* | "Manage Plan" |
*
* @param {Manageplan1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const manageplan1 = /** @type {((inputs?: Manageplan1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manageplan1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manageplan1(inputs)
	return de_manageplan1(inputs)
});
export { manageplan1 as "managePlan" }